function init() {
  document.querySelectorAll('.cartItem__quantityCell .spinner').forEach(quantitySpinner => {
    quantitySpinner.initialValue = quantitySpinner.value;
    quantitySpinner.addEventListener('change', e => quantityChangedHandler(quantitySpinner));
    quantityChangedHandler(quantitySpinner);
  })
}

function quantityChangedHandler(quantitySpinner) {
  const isInitial = (quantitySpinner.value === quantitySpinner.initialValue);
  const parentCell = quantitySpinner.closest('.cartItem__quantityCell');
  parentCell.classList.toggle('cartItem__quantityCell--changed', !isInitial);
  parentCell.querySelector('button[type=submit]').toggleAttribute('disabled', isInitial);
}

const cart = { init };
export default cart;